module.exports = __webpack_public_path__ + "static/media/video-cover.3d39c393.mp4";